export default {
  profile: 'Profile Information',
  welcome: 'Welcome',
  enter: 'Enter your email and password to login',
  email: 'E-Mail Address',
  required: 'email is a required field',
  remindme: 'Remind me',
  login: 'Sign in',
  loggingIn: 'Signing in...',
  logOut: 'Sign Out',
  signUp: 'Sign Up',
  alert: 'Incorrect username or password!',
  no_account: 'Don\'t have an account?',
  create_new_account: 'Enter your information',
  create_account: 'Sign Up',
  already_account: 'Do you have account already?',
  upss: 'Upss!',
  forbidden: 'Sorry, your access is refused due to security reasons of our server and also our sensitive data. \n\n Please go back to the previous page to continue browsing.',
  go_back: 'Go Back',
  fields: {
    name: 'Name',
    email: 'E-Mail Address',
    password: 'Password',
    confirm_password: 'Confirm your password',
    phone: 'Phone',
    phone2: 'Phone 2',
    roles: 'Roles',
    admin: 'Administrator',
    operator: 'Operator',
    superadmin: 'Super Administrator',
    role: 'Role',
    device: 'Device',
    status: 'Status'
  },
  platform_settings: 'Platform Settings',
  forms: {
    edit: 'Edit user information',
    edit_password: 'Enter your new password',
    upload: 'Upload photo profile',
    select_img: 'Choose image from files'
  },
  loginErrors: {
    invalidCredentials: {
      title: 'We could not sign you in',
      message: 'Check your email and password, then try again.'
    },
    missingProfile: {
      title: 'Your account is not ready yet',
      message: 'Authentication succeeded, but your user is not available or enabled in the admin panel yet.'
    },
    serverError: {
      title: 'We could not complete the sign-in',
      message: 'There was a problem loading your profile. Please try again in a few seconds.'
    }
  },
  messages: {
    enabled: 'User has been enabled!',
    disabled: 'User has been disabled!',
    permissions: 'You do not have permissions to perform this action!'
  }
}
